export const environment = {
  production: true,
  apiUrl: 'https://backend-production-5fe1.up.railway.app/api',
}
